
import { useQuery } from "@tanstack/react-query";
import { fetchDashboardData } from "@/utils/dashboardFetcher";
import { DashboardData } from "@/types/dashboard";
import { useLanguage } from "./useLanguage";
import { useToast } from "./use-toast";

export function useDashboardData(days: number = 30) {
  const { language } = useLanguage();
  const { toast } = useToast();

  console.log("useDashboardData: Current language:", language, "Days:", days);

  const {
    data = {},
    isLoading,
    error,
    isError,
    refetch,
    isRefetching,
  } = useQuery<DashboardData, Error>({
    queryKey: ['dashboard', language, days], // Include days in query key
    queryFn: () => fetchDashboardData(language, days), // Pass days to fetcher
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
    retry: 1,
  });

  // Show error toast when there's an error
  if (isError && error) {
    console.error("Error in useDashboardData hook:", error);
    toast({
      title: "Error loading dashboard",
      description: "Could not load dashboard data. Please try again later.",
      variant: "destructive",
    });
  }

  return {
    data,
    isLoading,
    error,
    isError,
    refetch,
    isRefetching,
  };
}
